import { TableCell, StatusCell } from 'ui/tableCell';
import { FlexSpacer } from 'ui/flexSpacer';
import { InfoBadge } from 'ui/badge';
import { AuthedEmailsTableActionButton } from './components/AuthedEmailsTableActionButton';
import type { AuthedEmailTableColumnData, SmsSendersTableColumnData } from './types';

export const AUTHED_EMAILS_TABLE_COLUMNS: AuthedEmailTableColumnData[] = [
  {
    name: 'From email',
    align: 'flex-start',
    value: 'email',
    RowCell: ({ row }) => {
      const emailSenderDataTestVal = row.isDefaultSender
        ? 'senders-authed-emails-table-row-default-sender-email'
        : 'senders-authed-emails-table-row-sender-email';
      return (
        <TableCell>
          <FlexSpacer>
            <span data-test={emailSenderDataTestVal}>{row.email}</span>
            {row.isDefaultSender && <InfoBadge>Default sender</InfoBadge>}
          </FlexSpacer>
        </TableCell>
      );
    },
  },
  {
    name: 'From name',
    align: 'flex-start',
    value: 'senderName',
    RowCell: ({ row }) => <TableCell>{row.senderName}</TableCell>,
  },
  {
    name: 'Default Reply-To',
    align: 'flex-start',
    value: 'defaultReplyTo',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.defaultReplyTo}</TableCell>,
  },
  {
    name: 'Verified',
    align: 'flex-start',
    value: 'authorized',
    sortable: false,
    RowCell: ({ row }) => <StatusCell showPositiveState={row.authorized} />,
  },
  {
    name: '',
    align: 'flex-end',
    value: '',
    sortable: false,
    RowCell: ({ row }) => <AuthedEmailsTableActionButton authedEmail={row} />,
  },
];

export const SMS_SENDERS_TABLE_COLUMNS: SmsSendersTableColumnData[] = [
  {
    name: 'ID',
    align: 'flex-start',
    value: 'id',
    RowCell: ({ row }) => <TableCell>{row.id}</TableCell>,
  },
  {
    name: 'Name',
    align: 'flex-start',
    value: 'name',
    RowCell: ({ row }) => <TableCell>{row.name}</TableCell>,
  },
  {
    name: 'Sending platform',
    align: 'flex-start',
    value: 'espDescription',
    RowCell: ({ row }) => <TableCell>{row.espDescription}</TableCell>,
  },
  {
    name: 'Message Service SID or Message Profile ID',
    align: 'flex-start',
    value: 'phoneNumber',
    RowCell: ({ row }) => <TableCell>{row.phoneNumber}</TableCell>,
  },
  {
    name: 'Number type',
    align: 'flex-start',
    value: 'type',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.type}</TableCell>,
  },
  {
    name: 'Message type',
    align: 'flex-start',
    value: 'messageTypeDescription',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.messageTypeDescription}</TableCell>,
  },
];
